import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User was shown the Edit in Canvas jobs of an asset menu: the Edit in Canvas submenu of a gallery or table item, multi-select context or ellipsis menu, the selection action bar menu, or the asset modal header menu, or the dropdown of the selection action bar Edit in Canvas icon (both selection bar surfaces report action_bar). On mobile the action sheet lists the submenu inline, so it is sent when the sheet opens. Fires in both arms of the Resize for set experiment and is the exposure event for that experiment. Sent at most once per pointer press for the same surface and clips, so moving between submenus does not resend it. Feature flags that have not loaded yet read as off, and saved sizes that are loading or failed to load read as no set, so a menu opened right after page load or after a failed fetch can report size_set_eligible false.',
  name: 'edit_in_canvas_submenu_shown',
  params: [
    {
      description:
        'The UI surface whose menu contains the Edit in Canvas submenu. asset_context_menu also covers private menus without their own value (e.g. kanban).',
      name: 'opened_from',
      required: true,
      type: 'enum',
      values: [
        'action_bar',
        'asset_context_menu',
        'asset_modal_header_menu',
        'gallery_item_context_menu',
        'gallery_item_ellipsis_menu',
        'gallery_multi_select_context_menu',
        'gallery_multi_select_ellipsis_menu',
        'table_item_context_menu',
        'table_item_ellipsis_menu',
        'table_multi_select_context_menu',
        'table_multi_select_ellipsis_menu',
      ],
    },
    {
      description: 'How many clips the submenu acts on',
      name: 'clip_count',
      required: true,
      type: 'number',
    },
    {
      description:
        'The Edit in Canvas jobs shown in the submenu, in display order, including "open" (More edits in Canvas)',
      name: 'tool_actions',
      required: true,
      type: 'array',
      values: [
        'add_solid_background',
        'adjust_image',
        'camera_angle',
        'change_lighting',
        'convert',
        'convert_to_gif',
        'crop',
        'edit_text',
        'erase',
        'extend_background',
        'flip_and_rotate',
        'image_to_video',
        'open',
        'prompt',
        'remove_background',
        'resize_for_set',
        'smart_resize',
        'split_elements',
        'translate',
        'upscale',
      ],
    },
    {
      description:
        'Whether the submenu qualifies for Resize for [set name]: a single image clip, opened from a single-asset menu (not the selection action bar or a multi-select menu, even when only one selected clip can open), saved sizes are available to this user, and the workspace has a saved size set that resolves to at least one image size. Computed the same way in both experiment arms.',
      name: 'size_set_eligible',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Whether the Resize for [set name] item was actually rendered in this submenu',
      name: 'size_set_offered',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'The id of the saved size set the Resize for [set name] item would use. Sent when size_set_eligible is true.',
      name: 'size_set_id',
      required: false,
      type: 'string',
    },
    {
      description:
        'How many sizes the saved size set resolves to (the "N sizes" shown on the item). Sent when size_set_eligible is true.',
      name: 'size_set_format_count',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
